// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__-iu6R","noInteraction":"EventWrapper_noInteraction__20vaj"};